import { memo, RefAttributes } from 'react';
import { Menu as RACMenu, MenuProps as RACMenuProps } from 'react-aria-components';

import { merge } from '@/components';

export type MenuProps<T extends object> = RACMenuProps<T> & RefAttributes<HTMLDivElement>;

const IMenu = <T extends object>({ className, children, ...rest }: MenuProps<T>) => {
  return (
    <RACMenu aria-label="menu" className={merge('outline-none', className)} {...rest}>
      {children}
    </RACMenu>
  );
};

export const Menu = memo(IMenu) as typeof IMenu;
